function priceSlider() {
  const slider = document.getElementById('slider');
  const priceInputs = document.querySelectorAll('.category__price-input input');

  if (!slider) return;

  noUiSlider.create(slider, {
    start: [99, 300],
    range: {
      'min': 99,
      'max': 300
    },
    connect: true,
    step: 1,
  });

  priceInputs.forEach(input => {
    input.addEventListener('input', () => {
      const value = input.value;
      slider.noUiSlider.set([value, value]);
    });
  });

  slider.noUiSlider.on('update', (values, handle, unencoded) => {
    priceInputs[0].value = unencoded[0];
    priceInputs[1].value = unencoded[1];
  });

  slider.noUiSlider.on('change', (values, handle, unencoded) => {
    priceInputs[0].value = unencoded[0];
    priceInputs[1].value = unencoded[1];
  });

  slider.noUiSlider.on('set', (values, handle, unencoded) => {
    priceInputs[0].value = unencoded[0];
    priceInputs[1].value = unencoded[1];
  });
}

export { priceSlider };